export default __webpack_public_path__ + "static/media/Slider-1_compressed.d04a116f.jpg";